import React from "react";
import ReactDOM from "react-dom";
import Router from "./routes/Router";
import reportWebVitals from "./reportWebVitals";
import "./styles/global.scss";
import { TestProvider } from "./context/TestContext";
import { SessionProvider } from "./context/Session";

ReactDOM.render(
  <React.StrictMode>
    <SessionProvider>
      <TestProvider>
        <Router />
      </TestProvider>
    </SessionProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
